/* VELTOPEAK — interacciones propias (vanilla, sin librerías) */
(function () {
  if (window.__vpInit) return;
  window.__vpInit = true;

  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var io = null;

  function once(el, key) {
    if (!el || el.dataset[key]) return false;
    el.dataset[key] = '1';
    return true;
  }

  /* ---------- Reveals al hacer scroll ---------- */
  function initReveals(root) {
    var els = (root || document).querySelectorAll('.vp-reveal:not(.vp-hero .vp-reveal), .vp-steps, .vp-cmp');
    if (!('IntersectionObserver' in window) || reduce) {
      els.forEach(function (el) { el.classList.add('vp-visible'); });
      return;
    }
    if (!io) {
      io = new IntersectionObserver(function (entries) {
        entries.forEach(function (e) {
          if (e.isIntersecting) { e.target.classList.add('vp-visible'); io.unobserve(e.target); }
        });
      }, { threshold: 0.08, rootMargin: '0px 0px -30px 0px' });
    }
    els.forEach(function (el) { if (once(el, 'vpObs')) io.observe(el); });
  }

  /* ---------- Héroe: foco que sigue al cursor + zoom-out ---------- */
  function initHero(root) {
    (root || document).querySelectorAll('[data-vp-hero]').forEach(function (hero) {
      if (!once(hero, 'vpHero')) return;
      requestAnimationFrame(function () { hero.classList.add('vp-loaded'); });
      if (reduce || window.matchMedia('(hover: none)').matches) return;
      var wrap = hero.closest('.shopify-section') || hero;
      var raf = null;
      wrap.addEventListener('pointermove', function (ev) {
        if (raf) return;
        raf = requestAnimationFrame(function () {
          var r = wrap.getBoundingClientRect();
          hero.style.setProperty('--vp-mx', ((ev.clientX - r.left) / r.width * 100).toFixed(1) + '%');
          hero.style.setProperty('--vp-my', ((ev.clientY - r.top) / r.height * 100).toFixed(1) + '%');
          raf = null;
        });
      });
    });
  }

  /* ---------- Manifiesto palabra a palabra ---------- */
  function initManifesto(root) {
    (root || document).querySelectorAll('[data-vp-manifesto]').forEach(function (el) {
      if (!once(el, 'vpMan')) return;
      if (reduce) return;
      var words = el.querySelectorAll('.vp-w');
      if (!words.length) return;
      el.setAttribute('data-mode', 'js');
      var ticking = false;
      function update() {
        var r = el.getBoundingClientRect();
        var vh = window.innerHeight;
        var start = vh * 0.85, end = vh * 0.35;
        var p = (start - r.top) / (start - end + r.height * 0.6);
        p = Math.max(0, Math.min(1, p));
        var n = Math.round(p * words.length);
        for (var i = 0; i < words.length; i++) words[i].classList.toggle('is-on', i < n);
        ticking = false;
      }
      window.addEventListener('scroll', function () { if (!ticking) { ticking = true; requestAnimationFrame(update); } }, { passive: true });
      update();
    });
  }

  /* ---------- Hotspots ---------- */
  function initHotspots(root) {
    (root || document).querySelectorAll('[data-vp-hotspots]').forEach(function (sec) {
      if (!once(sec, 'vpHs')) return;
      var dots = sec.querySelectorAll('.vp-hs__dot');
      var items = sec.querySelectorAll('.vp-hs__item');
      function activate(i) {
        dots.forEach(function (d, k) { d.classList.toggle('is-active', k === i); });
        items.forEach(function (d, k) { d.classList.toggle('is-active', k === i); });
      }
      dots.forEach(function (d, i) {
        d.addEventListener('mouseenter', function () { activate(i); });
        d.addEventListener('click', function () {
          activate(i);
          if (window.innerWidth < 990 && items[i]) items[i].scrollIntoView({ behavior: reduce ? 'auto' : 'smooth', block: 'nearest' });
        });
      });
      items.forEach(function (it, i) {
        it.addEventListener('mouseenter', function () { activate(i); });
        it.addEventListener('click', function () { activate(i); });
      });
      activate(0);
    });
  }

  /* ---------- Selector de colores (landing) ---------- */
  function initColors(root) {
    (root || document).querySelectorAll('[data-vp-colors]').forEach(function (sec) {
      if (!once(sec, 'vpCol')) return;
      var sw = sec.querySelectorAll('.vp-swatch');
      var imgs = sec.querySelectorAll('.vp-colors__stage img');
      var desc = sec.querySelector('.vp-colors__desc');
      var name = sec.querySelector('[data-vp-color-name]');
      var cta = sec.querySelector('[data-vp-color-cta]');
      var glow = sec.querySelector('.vp-colors__glow');
      function set(i) {
        sw.forEach(function (s, k) { s.classList.toggle('is-active', k === i); s.setAttribute('aria-pressed', k === i ? 'true' : 'false'); });
        imgs.forEach(function (im, k) { im.classList.toggle('is-active', k === i); });
        var s = sw[i];
        if (!s) return;
        if (desc) desc.textContent = s.dataset.desc || '';
        if (name) name.textContent = s.dataset.name || '';
        if (glow) glow.style.background = s.dataset.color || 'transparent';
        if (cta && s.dataset.url) cta.setAttribute('href', s.dataset.url);
      }
      sw.forEach(function (s, i) { s.addEventListener('click', function () { set(i); }); });
      set(0);
    });
  }

  /* ---------- FAQ ---------- */
  function initFaq(root) {
    (root || document).querySelectorAll('.vp-faq__item').forEach(function (it) {
      if (!once(it, 'vpFaq')) return;
      var btn = it.querySelector('.vp-faq__q');
      btn.addEventListener('click', function () {
        var open = it.classList.toggle('is-open');
        btn.setAttribute('aria-expanded', open ? 'true' : 'false');
      });
    });
  }

  /* ---------- Fecha estimada de entrega (días laborables) ---------- */
  function addBusinessDays(d, n) {
    var r = new Date(d.getTime());
    var added = 0;
    while (added < n) {
      r.setDate(r.getDate() + 1);
      var wd = r.getDay();
      if (wd !== 0 && wd !== 6) added++;
    }
    return r;
  }
  function initEta(root) {
    (root || document).querySelectorAll('[data-vp-eta]').forEach(function (el) {
      if (!once(el, 'vpEta')) return;
      var min = parseInt(el.dataset.min, 10) || 7;
      var max = parseInt(el.dataset.max, 10) || 12;
      var now = new Date();
      var f = { day: 'numeric', month: 'long' };
      var loc = document.documentElement.lang || 'es';
      var a = addBusinessDays(now, min).toLocaleDateString(loc, f);
      var b = addBusinessDays(now, max).toLocaleDateString(loc, f);
      var tpl = el.dataset.tpl || 'Pídelo hoy y recíbelo entre el {a} y el {b}';
      var out = el.querySelector('[data-vp-eta-text]');
      if (out) out.innerHTML = tpl.replace('{a}', '<strong>' + a + '</strong>').replace('{b}', '<strong>' + b + '</strong>');
    });
  }

  /* ---------- Producto: galería, variantes, cantidad, barra fija, visor ---------- */
  function initProduct(root) {
    (root || document).querySelectorAll('[data-vp-product]').forEach(function (sec) {
      if (!once(sec, 'vpPdp')) return;
      var dataEl = sec.querySelector('[data-vp-variants]');
      var variants = [];
      try { variants = JSON.parse(dataEl ? dataEl.textContent : '[]'); } catch (e) { variants = []; }

      /* Galería */
      var slides = sec.querySelectorAll('.vp-gallery__slide');
      var thumbs = sec.querySelectorAll('.vp-gallery__thumb');
      var current = 0;
      function show(i) {
        if (!slides.length) return;
        current = (i + slides.length) % slides.length;
        slides.forEach(function (s, k) { s.classList.toggle('is-active', k === current); });
        thumbs.forEach(function (t, k) { t.classList.toggle('is-active', k === current); });
        var th = thumbs[current];
        if (th && th.parentNode) {
          var p = th.parentNode;
          var left = th.offsetLeft - p.clientWidth / 2 + th.clientWidth / 2;
          p.scrollTo({ left: left, behavior: reduce ? 'auto' : 'smooth' });
        }
      }
      thumbs.forEach(function (t, i) { t.addEventListener('click', function () { show(i); }); });
      var prev = sec.querySelector('.vp-gallery__nav--prev');
      var next = sec.querySelector('.vp-gallery__nav--next');
      if (prev) prev.addEventListener('click', function (e) { e.stopPropagation(); show(current - 1); });
      if (next) next.addEventListener('click', function (e) { e.stopPropagation(); show(current + 1); });
      var main = sec.querySelector('.vp-gallery__main');
      if (main) {
        var sx = null;
        main.addEventListener('touchstart', function (e) { sx = e.touches[0].clientX; }, { passive: true });
        main.addEventListener('touchend', function (e) {
          if (sx === null) return;
          var dx = e.changedTouches[0].clientX - sx;
          if (Math.abs(dx) > 40) show(current + (dx < 0 ? 1 : -1));
          sx = null;
        });
      }

      /* Visor a pantalla completa con navegación entre TODAS las fotos */
      var lb = sec.querySelector('.vp-lb');
      if (lb && main) {
        var lbImg = lb.querySelector('img');
        var lbCount = lb.querySelector('.vp-lb__count');
        var srcs = Array.prototype.map.call(slides, function (s) { return s.dataset.full; });
        var li = 0;
        function lbShow(i) {
          li = (i + srcs.length) % srcs.length;
          lbImg.src = srcs[li];
          if (lbCount) lbCount.textContent = (li + 1) + ' / ' + srcs.length;
        }
        function lbOpen() { lbShow(current); lb.classList.add('is-open'); document.documentElement.style.overflow = 'hidden'; }
        function lbClose() { lb.classList.remove('is-open'); document.documentElement.style.overflow = ''; show(li); }
        main.addEventListener('click', lbOpen);
        lb.querySelector('.vp-lb__close').addEventListener('click', lbClose);
        lb.querySelector('.vp-lb__prev').addEventListener('click', function () { lbShow(li - 1); });
        lb.querySelector('.vp-lb__next').addEventListener('click', function () { lbShow(li + 1); });
        lb.addEventListener('click', function (e) { if (e.target === lb) lbClose(); });
        document.addEventListener('keydown', function (e) {
          if (!lb.classList.contains('is-open')) return;
          if (e.key === 'Escape') lbClose();
          if (e.key === 'ArrowLeft') lbShow(li - 1);
          if (e.key === 'ArrowRight') lbShow(li + 1);
        });
        var lsx = null;
        lb.addEventListener('touchstart', function (e) { lsx = e.touches[0].clientX; }, { passive: true });
        lb.addEventListener('touchend', function (e) {
          if (lsx === null) return;
          var dx = e.changedTouches[0].clientX - lsx;
          if (Math.abs(dx) > 40) lbShow(li + (dx < 0 ? 1 : -1));
          lsx = null;
        });
      }

      /* Variantes */
      var idInput = sec.querySelector('input[name="id"]');
      var priceEl = sec.querySelector('[data-vp-price]');
      var compareEl = sec.querySelector('[data-vp-compare]');
      var stickyPrice = sec.querySelector('[data-vp-sticky-price]');
      var addBtn = sec.querySelector('[data-vp-add]');
      var addLabel = addBtn ? addBtn.querySelector('span') : null;
      var labelAdd = addBtn ? addBtn.dataset.labelAdd : '';
      var labelSold = addBtn ? addBtn.dataset.labelSold : '';
      var groups = sec.querySelectorAll('[data-vp-option]');

      function selected() {
        var vals = [];
        groups.forEach(function (g) {
          var a = g.querySelector('.vp-opt__btn.is-active');
          vals[parseInt(g.dataset.vpOption, 10)] = a ? a.dataset.value : null;
        });
        return vals;
      }
      function findVariant(vals) {
        for (var i = 0; i < variants.length; i++) {
          var v = variants[i], ok = true;
          for (var k = 0; k < vals.length; k++) if (vals[k] !== null && v.options[k] !== vals[k]) { ok = false; break; }
          if (ok) return v;
        }
        return null;
      }
      function apply(v) {
        if (!v) return;
        if (idInput) idInput.value = v.id;
        if (priceEl) priceEl.textContent = v.price_fmt;
        if (stickyPrice) stickyPrice.textContent = v.price_fmt;
        if (compareEl) {
          if (v.compare_at_price && v.compare_at_price > v.price) { compareEl.textContent = v.compare_fmt; compareEl.hidden = false; }
          else compareEl.hidden = true;
        }
        if (addBtn) {
          if (v.available) { addBtn.removeAttribute('disabled'); addBtn.removeAttribute('aria-disabled'); if (addLabel) addLabel.textContent = labelAdd; }
          else { addBtn.setAttribute('disabled', 'disabled'); if (addLabel) addLabel.textContent = labelSold; }
        }
        sec.querySelectorAll('[data-vp-selected-label]').forEach(function (l) {
          var idx = parseInt(l.dataset.vpSelectedLabel, 10);
          l.textContent = v.options[idx] || '';
        });
        if (v.featured_media_id) {
          var idx2 = -1;
          slides.forEach(function (s, k) { if (String(s.dataset.mediaId) === String(v.featured_media_id)) idx2 = k; });
          if (idx2 > -1) show(idx2);
        }
        if (sec.dataset.updateUrl === 'true' && window.history && window.history.replaceState) {
          var url = new URL(window.location.href);
          url.searchParams.set('variant', v.id);
          window.history.replaceState({}, '', url.toString());
        }
      }
      groups.forEach(function (g) {
        g.querySelectorAll('.vp-opt__btn').forEach(function (b) {
          b.addEventListener('click', function () {
            g.querySelectorAll('.vp-opt__btn').forEach(function (x) { x.classList.remove('is-active'); x.setAttribute('aria-pressed', 'false'); });
            b.classList.add('is-active');
            b.setAttribute('aria-pressed', 'true');
            apply(findVariant(selected()));
          });
        });
      });

      /* Cantidad */
      var q = sec.querySelector('[data-vp-qty]');
      if (q) {
        var input = q.querySelector('input');
        q.querySelector('[data-vp-minus]').addEventListener('click', function () { input.value = Math.max(1, (parseInt(input.value, 10) || 1) - 1); });
        q.querySelector('[data-vp-plus]').addEventListener('click', function () { input.value = Math.min(99, (parseInt(input.value, 10) || 1) + 1); });
      }

      /* Barra fija de compra */
      var sticky = sec.querySelector('.vp-sticky');
      var formWrap = sec.querySelector('[data-vp-form-anchor]');
      if (sticky && formWrap && 'IntersectionObserver' in window) {
        document.body.appendChild(sticky);
        var seen = false;
        var obs = new IntersectionObserver(function (entries) {
          entries.forEach(function (e) {
            if (e.isIntersecting) { seen = true; sticky.classList.remove('is-on'); }
            else if (seen || e.boundingClientRect.top < 0) sticky.classList.toggle('is-on', e.boundingClientRect.top < 0);
          });
        }, { threshold: 0 });
        obs.observe(formWrap);
        var sb = sticky.querySelector('[data-vp-sticky-btn]');
        if (sb) sb.addEventListener('click', function (e) {
          e.preventDefault();
          if (addBtn && !addBtn.disabled) addBtn.click();
          else formWrap.scrollIntoView({ behavior: reduce ? 'auto' : 'smooth', block: 'center' });
        });
      }
    });
  }

  function initAll(e) {
    var root = e && e.target && e.target.querySelectorAll ? e.target : document;
    initReveals(root);
    initHero(root);
    initManifesto(root);
    initHotspots(root);
    initColors(root);
    initFaq(root);
    initEta(root);
    initProduct(root);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { initAll(); });
  else initAll();
  document.addEventListener('shopify:section:load', initAll);
})();
